import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { sanitizeHtml } from '../sanitize';

export class Announcement extends Component {
    static displayName = Announcement.name;

    constructor(props) {
        super(props);
        this.state = { 
            componentId: props.componentId,
            announcementText: null,
            isHidden: false
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    hideAnnouncement = () => {
        this.setState({
            isHidden: true
        });
    }

    decodeHtmlEntities = (text) => {
        if (!text) return '';
        
        // Create a temporary element to decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        let decodedText = textarea.value;
        
        // Check if the text still contains encoded HTML after first decode
        // This handles double-encoding scenarios
        if (decodedText.includes('&lt;') || decodedText.includes('&gt;') || decodedText.includes('&amp;')) {
            textarea.innerHTML = decodedText;
            decodedText = textarea.value;
        }
        
        return decodedText;
    }

    render() {
        //let componentContent = !this.state.isHidden ?
        //    <>
        //        <p className='announcement-title'>Alert</p>
        //        <p className='announcement-content'>{this.state.announcementText}</p>
        //        <p><span className='announcement-remove' alt="hide announcement" onClick={this.hideAnnouncement}><FontAwesomeIcon icon={faTimesCircle} /></span></p>
        //    </> : null;

        // Decode HTML entities to prevent displaying raw HTML tags
        const decodedText = this.decodeHtmlEntities(this.state.announcementText);

        let componentContent = !this.state.isHidden ?
            <>
                <p className='announcement-title'>Alert</p>
                <div className='general-html-editor-wrapper announcement-content' dangerouslySetInnerHTML={{ __html: sanitizeHtml(decodedText) }}></div>
                <p><button type="button" className='announcement-remove' aria-label="Hide announcement" onClick={this.hideAnnouncement}><FontAwesomeIcon icon={faTimesCircle} aria-hidden="true" /></button></p>
            </> : null;

        return (
            <div className='full-width-wrapper announcement-wrapper'>
                <div className="home-announce">
                    {componentContent}
                </div>
            </div>
        );
    }

    async getComponentData() {
         const response = await fetch('components/Announcement?componentId=' + this.state.componentId, {
            method: 'GET',
              headers: {
                'Content-Type': 'application/json',  
                'Accept': 'application/json'
              }
        });

        const data = await response.json();

        this.setState({
            announcementText: data.announcementText,
        });
    }
}